import React, { FC, useContext, useEffect, useState } from "react";
import Heading from "components/Heading/Heading";
import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";

import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import Avatar from "./Avatar";
import FooterNav from "components_custom/FooterNav/FooterNav";
import { useNavigate } from "react-router-dom";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonPrimary from "shared/Button/ButtonPrimary";

import { PhoneInput } from 'react-international-phone';
import { GlobalDataContext } from "contexts/GlobalData";
import { requestAPI } from "utils/api";
import Input from "shared/Input/Input";
import { UIContext } from "contexts/UIContext";
import { ArrowSmallLeftIcon } from "@heroicons/react/24/outline";

// THIS IS DEMO FOR MAIN DEMO
// OTHER DEMO WILL PASS PROPS
const postsDemo: PostDataType[] = DEMO_POSTS.filter((_, i) => i > 7 && i < 14);
//
export interface SectionLatestPostsProps {
	posts?: PostDataType[];
	className?: string;
	postCardName?: "card3";
}

const ModifyPhoneNumber: FC<any> = ({
	posts = postsDemo,
	postCardName = "card3",
	className = "",
}) => {

	const navigate = useNavigate ();

	const { 
		initData,
		setInitData,
	} = useContext (GlobalDataContext);

	const {
		toast,
	} = useContext(UIContext);  

	const [seconds, setSeconds] = useState(0);
	const [code, setCode] = useState('');
	const [phone, setPhone] = useState('');
	const [countryCallingNumber, setCountryCallingNumber] = useState('');
	const [verificationCode, setVerificationCode] = useState('');
	const [isSending, setSending] = useState(false);

	useEffect(()=>{
		
		if (initData.token_info.permission_group === "guest") {

			navigate('/me')	
		}	
		
	}, []);


	const getRemainingSeconds = (scheduleUTC: string) => {
		// 일정 UTC 시간 (2024-09-05T03:02:37.446Z)
		//const scheduleUTC = res_info.data.updatedAt;

		// UTC 시간을 한국 시간으로 변환
		const scheduleDate = new Date(scheduleUTC);
		const koreaTimeOffset = 9 * 60; // 한국은 UTC+9
		const scheduleKoreaTime: any = new Date(scheduleDate.getTime() + koreaTimeOffset * 60 * 1000);

		// 현재 한국 시간
		const now = new Date();
		const nowKoreaTime: any = new Date(now.getTime() + koreaTimeOffset * 60 * 1000);

		// 두 시간 차이 계산 (밀리초)
		const timeDiff = nowKoreaTime - scheduleKoreaTime;
		const threeMinutesInMs = 3 * 60 * 1000;

		const remainingTimeInMs = threeMinutesInMs - timeDiff;
		const remainingSeconds = Math.floor(remainingTimeInMs / 1000);

		return remainingSeconds;
	};
	
	let timer: any = 0;

	const handleCodeSubmit = async () => {

		const _initData = {...initData};
		const _id = _initData.userInfo._id;

		if (code === "") {
			return toast ({type: 'warning', contents: '인증 번호를 입력해 주세요'});
		}

		const res_info: any = await requestAPI ('PUT', `v1/user/${_id}/phonenumber-confirm`, {
			code
		});

		if (res_info.code === 1000) {
			clearInterval(timer);
			_initData.userInfo = res_info.data.userInfo;
			setInitData(_initData);
			navigate('/me');

		} else if (res_info.code === 4000) {
			toast ({
				type: 'warning', 
				contents: '이전 인증 번호는 시간 초과되어 다시 시도해 주세요'
			});		

			clearInterval(timer);
			setCode("");
			setSending(false);
		} else if (res_info.code === 4001) {

			toast ({
				type: 'warning', 
				contents: '인증 번호를 확인해 주세요'
			});		
		}
	};

	

	const handleSubmit = async () => {
		
		const _initData = {...initData};
		const _id = _initData.userInfo._id;
		const phoneNumber = phone.replace(`+${countryCallingNumber}`, '');

		if (phoneNumber === "") {
			toast ({type: 'warning', contents: '전화 번호를 입력해 주세요'});
			return 0;
		}

		const res_info: any = await requestAPI ('PUT', `v1/user/${_id}/phonenumber`, {
			countryCallingNumber,
			phoneNumber
		});

		if (res_info.code === 1000) {
			// 성공
			setCode("");
			setSending(true);

			const remainingSeconds = getRemainingSeconds(res_info.data.updatedAt);
			setSeconds(remainingSeconds);

			timer = setInterval(()=>{
				const remainingSeconds = getRemainingSeconds(res_info.data.updatedAt);
				setSeconds(remainingSeconds);

				if (remainingSeconds === 0) {
					clearInterval(timer);
					setCode("");
					setSending(false);
					return;
				}
			}, 1000);

		} else if (res_info.code === 1001) {
			// 이미 문자 발송

			toast ({
				type: 'warning', 
				contents: "이미 인증 번호가 발송되었어요, 인증 번호를 입력해 주세요"
			});

			const remainingSeconds = getRemainingSeconds(res_info.data.updatedAt);
			setSeconds(remainingSeconds);
			
			timer = setInterval(()=>{
				const remainingSeconds = getRemainingSeconds(res_info.data.updatedAt);
				setSeconds(remainingSeconds);

				if (remainingSeconds === 0) {
					clearInterval(timer);
					setCode("");
					setSending(false);
					return;
				}
			}, 1000);

			setSending(true);
			// _initData.userInfo = res_info.data.userInfo;
			// setInitData(_initData);
			// navigate('/me');
		} else if (res_info.code === 1002) {
			// 이미 인증 번호가 발송된 상태에서 다시 접근하여 다른 번호로 인증 시도 시

			const remainingSeconds = getRemainingSeconds(res_info.data.updatedAt);

			toast ({
				type: 'warning', 
				contents: `${remainingSeconds}초 뒤 다시 요청해 주세요`
			});

			setCode("");
			setSending(false);

			// _initData.userInfo = res_info.data.userInfo;
			// setInitData(_initData);
			// navigate('/me');
		} else if (res_info.code === 4000) {
			
			toast ({
				type: 'warning', 
				contents: '전화번호를 확인해 주세요'
			});
		} else if (res_info.code === 4001) {
			
			toast ({
				type: 'warning', 
				contents: '이미 존재하는 전화번호 이며 만약 본인의 휴대폰이라면 관리자에게 문의해 주세요'
			});
		}
	};
	
	const handleCancel = () => {
		navigate(-1);
	};

	const handleBack = () => {
		navigate(-1);
	}

	const changePhoneNumber = async (phone: string, meta: any) => {
		//console.log(meta)
		setCountryCallingNumber(meta.country.dialCode);
		setPhone(phone)
	};

	return (
		<>
			<div className={`container relative nc-SectionLatestPosts overflow-y ${className} h-screen bg-white !p-0 lg:w-[768px]`}>

				<div className="sticky inset-0 bg-white z-40 flex items-center justify-between">
					<div className="container flex items-center justify-between sm:w-[768px] !p-0 h-[62px]">
						<div className=" top-0 pt-4 pb-4 flex items-center justify-between bg-white">
							<button
								className="focus:outline-none focus:ring-0 w-10 h-10 rounded-full flex items-center justify-center hover:bg-neutral-100 ml-2"
								onClick={()=> handleBack()}
							>
								<ArrowSmallLeftIcon className="w-6 h-6" />
							</button>
							{/* <LikeSaveBtns /> */}
							<span
								className="text-xl"
							>
								뒤로
							</span>
						</div>
					</div>
				</div>

				<div className="flex flex-col lg:flex-row">
					<div className="w-full pl-[1rem] pr-[1rem]">
						<div className="mt-5" />
						<div
							className={`nc-Section-Heading relative flex flex-col sm:flex-row sm:items-end justify-between ${className}`}
							>
							<div
								className={`max-w-2xl`}
							>
								<h2 className={`text-3xl md:text-4xl font-semibold`}>
									휴대폰 번호 수정
								</h2>
							</div>
						</div>

						<div className="mt-10" />

						<div>
							<span
								className="text-xl font-semibold text-slate-600"
							>
								변경하실 이름을 입력해주세요
							</span>
						</div>
						<div>
							<span 
								className="text-sm text-slate-600"
							>
								현재 등록된 전화번호는 [{initData.userInfo.phoneNumberlast4}]이에요.
							</span>
						</div>

						<div className="mt-10" />

						{isSending
						?
							<>
								<div className="grid grid-cols-1 gap-6">
									<label className="block">
										<span className="text-neutral-800 dark:text-neutral-200">
											전화번호
										</span>
										<PhoneInput
											style={
												{
													'--react-international-phone-country-selector-border-color-hover': "black",
													'--react-international-phone-background-color': (localStorage.theme==="dark")? 'rgba(var(--c-neutral-900), var(--tw-bg-opacity))':'white',
													'--react-international-phone-country-selector-background-color-hover': (localStorage.theme==="dark")? 'rgba(var(--c-neutral-900), var(--tw-bg-opacity))':'',
													'--react-international-phone-selected-dropdown-item-text-color': (localStorage.theme==="dark")? 'white':'',
													'--react-international-phone-dropdown-item-text-color': (localStorage.theme==="dark")? 'white':'',
													'--react-international-phone-selected-dropdown-item-background-color': (localStorage.theme==="dark")? 'rgba(var(--c-neutral-700), var(--tw-bg-opacity))':'',
												} as React.CSSProperties
											}
											inputClassName={
												"block w-full border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900 text-sm font-normal h-11 px-4 py-3 mt-1"
											}
											defaultCountry="kr"
											value={phone}
											disabled
										/>
									</label>
								</div>
								<div className="grid grid-cols-1 gap-6 mt-5">
									<label className="block">
										<span className="text-neutral-800 dark:text-neutral-200">
											인증번호 (입력까지 남은 시간: {seconds}초)
										</span>
										<Input
											value={code}
											onChange={(e) => setCode(e.target.value)}
										/>
									</label>
								</div>

								<div className="flex flex-col mt-12 space-y-5 sm:space-y-0 sm:space-x-3 sm:flex-row justify-end">
									<ButtonPrimary
										onClick={() => handleCodeSubmit()}
									>
										확인
									</ButtonPrimary>
								</div>

							</>
						:
						<>
							<div className="grid grid-cols-1 gap-6">
								<label className="block">
									<span className="text-neutral-800 dark:text-neutral-200">
										전화번호
									</span>
									<PhoneInput
										style={
											{
												'--react-international-phone-country-selector-border-color-hover': "black",
												'--react-international-phone-background-color': (localStorage.theme==="dark")? 'rgba(var(--c-neutral-900), var(--tw-bg-opacity))':'white',
												'--react-international-phone-country-selector-background-color-hover': (localStorage.theme==="dark")? 'rgba(var(--c-neutral-900), var(--tw-bg-opacity))':'',
												'--react-international-phone-selected-dropdown-item-text-color': (localStorage.theme==="dark")? 'white':'',
												'--react-international-phone-dropdown-item-text-color': (localStorage.theme==="dark")? 'white':'',
												'--react-international-phone-selected-dropdown-item-background-color': (localStorage.theme==="dark")? 'rgba(var(--c-neutral-700), var(--tw-bg-opacity))':'',
											} as React.CSSProperties
										}
										inputClassName={
											"block w-full border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900 text-sm font-normal h-11 px-4 py-3 mt-1"
										}
										defaultCountry="kr"
										value={phone}
										onChange={(phone, meta) => changePhoneNumber(phone, meta)}
									/>
								</label>
							</div>

							<div className="flex flex-col mt-12 space-y-5 sm:space-y-0 sm:space-x-3 sm:flex-row justify-end">
								<ButtonSecondary
									onClick={() => handleCancel()}
								>
									취소
								</ButtonSecondary>
								<ButtonPrimary
									onClick={() => handleSubmit()}
								>
									수정
								</ButtonPrimary>
							</div>
						</>
						}
					</div>

				</div>
				
			</div>
		</>
	);
};

export default ModifyPhoneNumber;
